import { DATE_FORMAT_OPTIONS, formatDate } from "@/Core/Helpers/DayjsHelpers";
import { UserResponseDto } from "@/Dtos/user-dto";
import { PiCalendarBlankDuotone, PiClockDuotone } from "react-icons/pi";
import { Badge } from "rizzui";

export default function EmployeeInfo({
    employee,
}: {
    employee: UserResponseDto;
}) {
    return (
        <div className="mt-2 flex flex-col gap-y-6 @container sm:gap-y-10">
            {/* Employee Info */}
            <div className="grid items-start rounded-xl border border-gray-300 p-4 @2xl:grid-cols-2 @3xl:grid-cols-3 @3xl:p-7 @5xl:grid-cols-4">
                <ul className="grid gap-3 @3xl:col-span-full @3xl:mb-2 @5xl:col-span-1 @5xl:mb-0">
                    <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                        <span className="font-semibold text-gray-900">
                            Name :
                        </span>
                        <span className="text-base font-semibold text-gray-900">
                            {employee.name}
                        </span>
                    </li>
                    <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                        <span className="font-semibold text-gray-900">
                            Email :
                        </span>
                        <span className="text-base font-semibold text-gray-900">
                            {employee.email}
                        </span>
                    </li>
                    {/* <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                        <span className="font-semibold text-gray-900">
                            Company :
                        </span>
                        <Badge
                            color="success"
                            rounded="md"
                            className="capitalize"
                        >
                            {employee.company?.name ??
                                employee?.department?.company?.name}
                        </Badge>
                    </li> */}
                    <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                        <span className="font-semibold text-gray-900">
                            Status :
                        </span>
                        <Badge color="info" rounded="md" className="capitalize">
                            {employee.status}
                        </Badge>
                    </li>
                    {/* <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                        <span className="font-semibold text-gray-900">
                            Role :
                        </span>
                        <Badge
                            color="primary"
                            rounded="md"
                            className="capitalize"
                        >
                            {employee.role?.name}
                        </Badge>
                    </li> */}
                </ul>
                <ul className="mt-3 grid gap-3 @5xl:mt-0">
                    <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            Phone Number :
                        </span>
                        <span className="capitalize">
                            {employee.phoneNumber}
                        </span>
                    </li>
                    {/* <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            Department :
                        </span>
                        <span className="capitalize">
                            {employee.department?.name}
                        </span>
                    </li>
                    <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            Salary :
                        </span>
                        <span>{employee.salary}</span>
                    </li>
                    {employee.title && (
                        <li className="flex items-center gap-3">
                            <span className="font-semibold text-gray-900">
                                Title :
                            </span>
                            <span className="capitalize">
                                {employee.title?.name}
                            </span>
                        </li>
                    )}
                    {employee.position && (
                        <li className="flex items-center gap-3">
                            <span className="font-semibold text-gray-900">
                                Position :
                            </span>
                            <span className="capitalize">
                                {employee.position?.name}
                            </span>
                        </li>
                    )}

                    <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            Is Manager :
                        </span>
                        <Badge
                            color={employee.isManager ? "success" : "warning"}
                            rounded="md"
                            className="capitalize"
                        >
                            {employee.isManager ? "Yes" : "No"}
                        </Badge>
                    </li>
                    <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            Is Assistant :
                        </span>
                        <Badge
                            color={employee.isAssistant ? "success" : "info"}
                            rounded="md"
                            className="capitalize"
                        >
                            {employee.isAssistant ? "Yes" : "No"}
                        </Badge>
                    </li> */}
                </ul>
                <ul className="mt-3 grid gap-3 @5xl:mt-0">
                    {/* {employee.lastTimeLogin && (
                        <li className="flex items-center gap-3">
                            <span className="font-semibold text-gray-900">
                                Last Time Login :
                            </span>

                            <span className="flex items-center gap-1 rounded-md border border-muted px-1.5 py-1">
                                <PiCalendarBlankDuotone className="size-4" />
                                {formatDate({
                                    value: employee.lastTimeLogin ?? "",
                                    format: DATE_FORMAT_OPTIONS.LM,
                                })}
                                <PiClockDuotone className="size-4" />
                                {formatDate({
                                    value: employee.lastTimeLogin ?? "",
                                    format: DATE_FORMAT_OPTIONS.LT,
                                })}
                            </span>
                        </li>
                    )} */}
                    {/* <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            OTP Channel :
                        </span>
                        <span className="capitalize">
                            {employee.otpChannelType}
                        </span>
                    </li>
                    <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            Leave Balance :
                        </span>
                        <span>
                            {formatNumberWithCommas(employee.leaveBalance ?? 0)}
                        </span>
                    </li>
                    <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            Leave Taken :
                        </span>
                        <span>
                            {formatNumberWithCommas(
                                employee.totalLeaveTaken ?? 0,
                            )}
                        </span>
                    </li>

                    <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            On Leave :
                        </span>
                        <Badge
                            color={employee.isLeave ? "success" : "secondary"}
                            rounded="md"
                            className="capitalize"
                        >
                            {employee.isLeave ? "Yes" : "No"}
                        </Badge>
                    </li> */}
                </ul>

                <ul className="mt-3 grid gap-3 @5xl:mt-0">
                    <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            Created At :
                        </span>

                        <span className="flex items-center gap-1 rounded-md border border-muted px-1.5 py-1">
                            <PiCalendarBlankDuotone className="size-4" />
                            {formatDate({
                                value: employee.createdAt ?? "",
                                format: DATE_FORMAT_OPTIONS.LM,
                            })}
                            <PiClockDuotone className="size-4" />
                            {formatDate({
                                value: employee.createdAt ?? "",
                                format: DATE_FORMAT_OPTIONS.LT,
                            })}
                        </span>
                    </li>
                    <li className="flex items-center gap-3">
                        <span className="font-semibold text-gray-900">
                            Created By :
                        </span>

                        <span className="capitalize">{employee.createdBy}</span>
                    </li>
                    {employee.updatedAt && (
                        <li className="flex items-center gap-3">
                            <span className="font-semibold text-gray-900">
                                updated At :
                            </span>

                            <span className="flex items-center gap-1 rounded-md border border-muted px-2 py-1">
                                <PiCalendarBlankDuotone className="size-4" />
                                {formatDate({
                                    value: employee.updatedAt ?? "",
                                    format: DATE_FORMAT_OPTIONS.LM,
                                })}
                                <PiClockDuotone className="size-4" />
                                {formatDate({
                                    value: employee.updatedAt ?? "",
                                    format: DATE_FORMAT_OPTIONS.LT,
                                })}
                            </span>
                        </li>
                    )}
                </ul>

                {/* {data.map((item, index) => (
                    <ul key={index} className="mt-3 grid gap-3 @5xl:mt-0">
                        {Object.entries(item).map(([key, value]) => (
                            <li key={key} className="flex items-center gap-3">
                                <span className="font-semibold text-gray-900">
                                    {key} :
                                </span>
                                <span>{value}</span>
                            </li>
                        ))}
                    </ul>
                ))} */}
            </div>

            {/* Social Media */}
        </div>
    );
}
